<template>
  <div>
    <vxe-toolbar size="mini" v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="handleInsert"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('xTable.insert') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete"
          >{{ $t('xTable.delete') }}</vxe-button
        >
        <vxe-button type="primary" icon="el-icon-plus" class="vxe-btn-primary" @click="handleImport"
          >导入</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :data="tableData"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: this.activeRowMethod }"
      size="mini"
      ref="ruleTable"
      :edit-rules="validRules"
      :columns="columnList"
      :valid-config="{ autoPos: true, message: 'inline' }"
      @edit-closed="editClosedEvent"
      align="center"
      auto-resize
      show-footer
      :max-height="$store.state.app.tableHeight"
      :footer-method="footerMethod"
    >
    </vxe-grid>
    <batch-picking-dialog
      ref="batchPickingDialog"
      fromFlag="rowInfo"
      :basicData="baseInfo"
      @changeResult="changeResult"
    ></batch-picking-dialog>
    <sirui-upload
      :action="action"
      @ossSuccess="ossSuccess"
      ref="SiruiUpload"
      :data="{ ...tokenInfo }"
    ></sirui-upload>

    <SelectTableDialog
      title="添加商品"
      ref="selectTableDialog"
      :searchColumns="searchColumns"
      :columnList="columnListDialog"
      :defaultVisible="defaultVisible"
      :API="DialogAPI"
      :page="1 == 1"
      :extraData="extraData"
      :confirmUnchecked="false"
      :isMultiple="true"
      width="1200px"
      @close="closeDialog"
      @confirm="changeResult"
    >
    </SelectTableDialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  // import inputNumber from '@/components/form-item/input-number';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  // import searchTable from '@/components/form-item/search-table';
  // import dictSelect from '@/components/DictSelect';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  import API from '@/api/wareHouse/mcInbound.js';
  import BASE_API from '@/api/dataBase.js';
  // import Lad_API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill';
  // import RETURN_API from '@/api/purchaseSalesCenter/salesReturnsAndExchange';
  // import SALE_API from '@/api/purchaseSalesCenter/businessOrder.js';
  import batchPickingDialog from './batchPickingDialog';
  import siruiUpload from '@/components/SiruiUpload';
  // import loading from '@/common/js/load.js'; //loading
  import SelectTableDialog from '@/components/SelectTableDialog';
  import GOODS_API from '@/api/masterData/goods';
  export default {
    props: {
      canEdit: {
        type: Boolean,
        default: false,
      },
      validateInbound: {
        type: Function,
        default: null,
      },
      validateCost: {
        type: Function,
        default: null,
      },
      baseInfo: {
        type: Object,
        default: () => {},
      },
      currencyList: {
        type: Array,
        default: () => [],
      },
      dictList: {
        type: Object,
        default: () => {},
      },
      getPickingTableInfo: {
        type: Function,
        default: null,
      },
    },
    components: {
      // inputNumber,
      // searchTable,
      // ajaxSelect,
      // dictSelect,
      // inputNumberAd,
      siruiUpload,
      batchPickingDialog,
      SelectTableDialog,
    },
    data() {
      return {
        action: API.IMPORT_DETAIL,
        tableData: [],
        invoiceType: '',
        companyCode: '',
        taxRateList: [], //税率列表
        departmentList: [],
        rowAmount: {
          ladingQuantity: '',
          ladingAmount: '',
        },
        DialogAPI: GOODS_API.LIST_DETAIL_PRODUCT,
        extraData: {},
        defaultVisible: false,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
        searchColumns() {
          return [
            {
              prop: 'productDetailCode',
              name: '商品编码',
              type: 'input',
            },
            {
              prop: 'detailProductDisplayName',
              name: '商品名称',
              type: 'input',
            },
          ];
        },
        columnListDialog() {
          return [
            {
              prop: 'productDetailCode',
              label: '商品编码',
            },
            {
              prop: 'detailProductDisplayName',
              label: '商品名称',
            },
          ];
        },
      }),
      validRules() {
        const prefixInput = this.$t('mcInboundEdit.msg.rules.input');
        const prefixSelect = this.$t('mcInboundEdit.msg.rules.select');
        return {
          ladingQuantity: [
            {
              required: true,
              message: prefixInput + this.$t('mcInboundEdit.column.ladingQuantity'),
            },
          ],
          outboundStorageNo: [
            {
              required: true,
              message: prefixSelect + this.$t('mcInboundEdit.column.outboundStorageNo'),
            },
          ],
          // actualSendQuantity: [
          //   {
          //     required: true,
          //     message: prefixInput + this.$t('mcInboundEdit.column.actualSendQuantity'),
          //   }
          // ],
        };
      },

      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            title: this.$t('mcInboundEdit.column.sortNo'),
            field: 'sortNo',
            type: 'seq',
            width: 60,
          }, //序号
          { title: '行号', field: 'inboundPickNo', width: 60 }, //序号
          // {title: this.$t('mcInboundEdit.column.contractDetailNo'), field: "contractDetailNo", width: 200},//和同行项目号
          { title: this.$t('mcInboundEdit.column.productDesc'), field: 'productDesc', width: 200 }, //原材料描述
          { title: this.$t('mcInboundEdit.column.productNo'), field: 'productNo', width: 120 }, //原材料编码
          {
            title: this.$t('mcInboundEdit.column.ladingAmount'),
            field: 'ladingAmount',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.ladingAmount)}</span>];
              },
            },
          }, //原材料金额
          {
            title: this.$t('mcInboundEdit.column.ladingQuantity'),
            field: 'ladingQuantity',
            width: 120,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumnForNum(row.ladingQuantity)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['ladingQuantity']}
                    placeholder={this.$t('mcInboundEdit.column.ladingQuantityPlaceholder')}
                    clearable={true}
                    precision={3}
                    max={9999999999}
                    min={-9999999999}
                    maxLength={6}
                    onInput={(val) => this.updateCol(row, val, 'ladingQuantity')}
                  ></input-number-ad>,
                ];
              },
            },
          }, //原材料数量
          {
            title: this.$t('mcInboundEdit.column.actualSendQuantity'),
            field: 'actualSendQuantity',
            width: 180,
          }, //实发数量
          // {title: this.$t('mcInboundEdit.column.customerReceiveQuantity'), field: "customerReceiveQuantity", width: 180,},//实收数量
          {
            title: this.$t('mcInboundEdit.column.ladingUnit'),
            field: 'ladingUnit',
            width: 120,
            editRender: {
              name: 'ElSelect',
              options: this.dictList.unitOptions,
              props: { clearable: true, filterable: true, disabled: true },
            },
          }, //计量单位
          // {title: this.$t('mcInboundEdit.column.overShippedPercentage'), field: "overShippedPercentage", width: 120},//溢装比例
          // {title: this.$t('mcInboundEdit.column.shortShippedPercentage'), field: "shortShippedPercentage", width: 120},//短装比例
          // {title: this.$t('mcInboundEdit.column.outboundStorageNo'), field: "outboundStorageNo", width: 180,
          //   editRender: {},
          //   slots: {
          //     // 使用 JSX 渲染
          //     default: ({ row }) => {
          //       return [
          //         <span>{ row.outboundStorageNo}</span>
          //       ]
          //     },
          //     edit: ({ row }) => {
          //       return [
          //         <search-table
          //           v-model="row.outboundStorageNo"
          //           searchType="warehouse"
          //           isMultiple={true}
          //           currentValue={row['outboundStorageName']}
          //           checkRowKeys={[row['outboundStorageNo']]}
          //           onInput={val => this.updateCol(row, val, 'outboundStorageNo')}
          //           extraData={
          //             {
          //             }
          //           }
          //         ></search-table>
          //       ]
          //     }
          //   }
          // },//出库仓库 */
          // {title: this.$t('mcInboundEdit.column.isCompleteDelivery'), field: "isCompleteDelivery", width: 120},//是否完全发货
        ];
      },
    },
    mounted() {
      //税率
      this.$baseRequest.getTaxRate().then((res) => {
        this.taxRateList = res.filter((it) => it.taxType == 'OT');
      });
    },
    watch: {
      //监听发票信息变化 更新表格币种汇率等
      invoiceInfo: {
        handler(newV, oldV) {
          let fulldata = this.$refs.ruleTable.getTableData().fullData;
          fulldata = fulldata.map((item) => {
            item.currency = newV.currency;
            item.exchangeRate = newV.exchangeRate;
            return item;
          });
          this.$refs.ruleTable.updateData(fulldata);

          if (newV.invoiceCompanyCode && newV.invoiceCompanyCode != oldV.invoiceCompanyCode)
            this.getLastDepart(newV.invoiceCompanyCode);
        },
        deep: true,
      },
    },
    methods: {
      closeDialog() {
        this.defaultVisible = false;
        this.extraData = {};
        // ================= 清空选中 =================
        this.$refs.selectTableDialog.$refs.siruiTable.clearSelectRecord();
        // ============================================
      },
      ossSuccess(response) {
        let list = response.data;
        list.map((item) => {
          let params = this.$baseRequest.assignObj(item);
          this.$refs.ruleTable
            .insertAt(params, -1)
            .then(({ row }) => this.$refs.ruleTable.setActiveRow(row));
        });
      },
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true);
      },
      handleInsert() {
        this.validateInbound()
          .then(
            this.validateCost().then(() => {
              // const userInfo = this.userInfo;
              this.defaultVisible = true;
            })
          )
          .catch(() => {
            console.log('handleInsertErr');
          });
      },
      // 新增弹框回调
      changeResult(resultArr) {
        console.log(resultArr);

        this.closeDialog();
        // let params = [];
        let existProduct = [];
        let tableData = this.$refs.ruleTable.getTableData().fullData.map((item) => item.productNo);
        resultArr.map((item) => {
          // let fulldata = this.$refs.ruleTable.getTableData().fullData;
          // let curIndex = fulldata.length + index +1
          let curIndex = this.$baseRequest.getNewDetailNo(this.$refs.ruleTable, 'inboundPickNo');
          console.log(curIndex);
          let obj = {
            inboundPickNo: curIndex,
            productNo: item.productDetailCode,
            productDesc: item.detailProductDisplayName,
            ladingUnit: item.basicUnit,
          };
          if (tableData.includes(obj.productNo)) {
            existProduct.push(obj.productDesc);
          } else {
            obj = this.$baseRequest.assignObj(obj);
            this.$refs.ruleTable
              .insertAt(obj, -1)
              .then(({ row }) => this.$refs.ruleTable.setActiveRow(row));
            // params.push(obj)
          }
        });
        if (existProduct[0]) {
          let msg = '商品（' + existProduct.join(',') + '）已存在不可重复添加!';
          this.$message({
            showClose: true,
            message: msg,
            type: 'error',
          });
        }
      },
      // 合计
      footerMethod({ columns, data }) {
        let returnAmountProps = ['ladingQuantity', 'ladingAmount'];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (returnAmountProps.includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(
                  data[i][column.property] || 0,
                  subtrahend,
                  '+',
                  'price'
                );
              }
              if (column.property == 'ladingQuantity') {
                this.rowAmount.ladingQuantity = subtrahend;
                subtrahend = this.$baseRequest.formatTableColumnForNum(subtrahend); //转换成三位小数
              }
              if (column.property == 'ladingAmount') {
                subtrahend = this.$baseRequest.formatTableColumn(subtrahend); //转换成两位小数
                this.rowAmount.ladingAmount = subtrahend;
              }
              this.$emit('updateCostInfo', this.rowAmount);
              return subtrahend;
            }
            return null;
          }),
        ];
      },
      // 取一级部门的最后一级部门
      async getLastDepart(v) {
        this.departmentList = [];
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: v,
        };
        const selectStatus = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personDepartmentInfo = selectStatus.data.data.personDepartmentInfo || [];
          if (personDepartmentInfo[0]) {
            this.departmentList = personDepartmentInfo.map((it) => {
              return { value: it.personDepartmentCode, label: it.personDepartmentName };
            });
          }
          console.log(this.departmentList);
        }
      },
      activeRowMethod() {
        //禁用编辑
        console.log(this.canEdit);
        return this.canEdit;
      },
      // editRender更新字段
      updateEvent(obj) {
        console.log(obj);
        let row = obj.row;
        row['taxRate'] = this.taxRateList.find((it) => it.taxCode == row.taxCode).taxRate;
        console.log(row);
      },
      //JSX更新字段
      updateCol(row, val, type) {
        console.log(1);
        row[type] = val;
        if (type == 'ladingQuantity') {
          //原材料数量
          console.log(row.ladingQuantity);
          let pickingTableInfo = this.getPickingTableInfo();
          console.log(pickingTableInfo);
          row['actualSendQuantity'] = row['ladingQuantity']; //实发数量=原材料数量
          if (
            pickingTableInfo.storageLadingPickingDetailList.filter(
              (item) => item.inboundPickNo == row['inboundPickNo']
            )[0]
          ) {
            let msg = '存在明细已完成拣配，修改将会删除对应拣配信息';
            let title = '是否修改？';
            this.$confirmAction(msg, title)
              .then(() => {
                this.$emit('restPickDetail', row['inboundPickNo']);
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: this.$t('message.success'),
                });
              })
              .catch(() => {
                this.$message({
                  showClose: true,
                  type: 'info',
                  message: this.$t('message.cancle'),
                });
              });
          }
        } else if (type == 'outboundStorageNo') {
          console.log(row[type]);
          console.log(val);
          this.tableData.outboundStorageNo = row[type][0].storageCode || '';
          this.tableData.outboundStorageName = row[type][0].storageName || '';
        }
        this.$emit('updateCostInfo', this.rowAmount);
      },

      editClosedEvent(row) {
        console.log(row);
      },
      updateRow(row, obj) {
        row.invoiceAmount = obj.invoiceAmount;
        row.excludedTaxAmount = obj.excludedTaxAmount;
        row.taxAmount = obj.taxAmount;
        row.invoiceAccountedAmount = obj.invoiceAccountedAmount;
        row.excludedTaxAccountedAmount = obj.excludedTaxAccountedAmount;
        row.taxAccountedAmount = obj.taxAccountedAmount;
        row.ladingDifferenceAmount = obj.ladingDifferenceAmount;
        row.recoverableTaxAmount = obj.recoverableTaxAmount;
      },
      getValues() {
        const allData = this.$refs['ruleTable'].getTableData();
        const tableData = allData.fullData;
        return tableData.map((item, index) => {
          const result = Object.assign({}, item, {
            invoiceDetailCode: item.invoiceDetailCode || index + 1,
          });
          return result;
        });
      },
      handleDelete() {
        const selectedList = this.$refs['ruleTable'].getCheckboxRecords(); // 选中数据
        console.log(selectedList);
        console.log(selectedList.length);
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        //获取拣配数据对象
        let pickingTableInfo = this.getPickingTableInfo();
        console.log(pickingTableInfo);
        let msg = '是否确认删除';
        let exsitDetail = [];
        selectedList.forEach((val) => {
          exsitDetail.push(
            pickingTableInfo.storageLadingPickingDetailList.filter(
              (item) => item.inboundPickNo == val.inboundPickNo
            )
          );
          if (
            pickingTableInfo.storageLadingPickingDetailList.filter(
              (item) => item.inboundPickNo == val.inboundPickNo
            )[0]
          )
            msg = '存在明细已完成拣配确认删除,重新拣配？';
        });
        console.log(exsitDetail);
        this.$confirmAction(msg)
          .then(() => {
            this.$refs['ruleTable'].removeSelecteds();
            // 存在已关联拣配结果
            /* if(exsitDetail[0]){
            this.$emit("restPickDetail",selectedList[0].inboundPickNo)
          }else{
            this.$emit("restPickDetail",selectedList[0].inboundPickNo)
          } */
            let inboundPickNoList = [];
            selectedList.forEach((item) => {
              inboundPickNoList.push(item.inboundPickNo);
              console.log(item.inboundPickNo);
            });
            this.$emit('restPickDetail', inboundPickNoList);
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.success'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('message.cancle'),
            });
          });
      },
      // 生成校验规则
      getRules() {
        const emptyTip = this.$t('contractAgency.productTab.emptyTip');
        const rules = {};
        this.columnsList.forEach((item) => {
          const required = typeof item.required === 'function' ? item.required() : item.required;
          if (required) {
            const title = this.$t('saleInvoice.' + (item.otherKey || item.field));
            const message = title + emptyTip;
            rules[item.field] = [{ required: true, message: message }];
          }
        });
        return rules;
      },
      // 币种格式转换
      fotmatCurrency({ cellValue }) {
        console.log(cellValue);
        if (cellValue)
          return this.currencyList.find((it) => it.currencyCode == cellValue).currencyName;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .price-col {
    line-height: 18px;
  }
</style>
